/*! @pentacode/ui v0.1.0 */
import { noChange as e } from "lit";
import { AsyncDirective as t, directive as n } from "lit/async-directive.js";
import { PartType as r } from "lit/directive.js";
var i = n(class extends t {
	constructor(e) {
		if (super(e), this._element = null, this._isDockedAtBottom = !0, this._tolerance = 10, this._options = {}, this._handleScroll = () => {
			if (!this._element) return;
			let { scrollTop: e, clientHeight: t, scrollHeight: n } = this._element;
			this._isDockedAtBottom = n - e - t <= this._tolerance;
		}, this._controller = { scrollToBottom: (e = !1) => {
			this._element && (e || this._isDockedAtBottom) && requestAnimationFrame(() => {
				this._element && (this._element.scrollTop = this._element.scrollHeight, this._handleScroll());
			});
		} }, e.type !== r.ELEMENT) throw Error("scrollTrap directive must be used on an element");
	}
	render(t) {
		return e;
	}
	update(t, [n]) {
		let r = t.element;
		return this._element !== r && (this._cleanup(), this._element = r, r.addEventListener("scroll", this._handleScroll)), this._tolerance = n?.tolerance ?? 10, n?.onAttach && n !== this._options && n.onAttach(this._controller), this._options = n ?? {}, e;
	}
	_cleanup() {
		this._element?.removeEventListener("scroll", this._handleScroll), this._options.onDetach?.(), this._element = null, this._isDockedAtBottom = !0;
	}
	disconnected() {
		this._cleanup();
	}
	reconnected() {
		this._element && (this._element.addEventListener("scroll", this._handleScroll), this._options.onAttach && this._options.onAttach(this._controller));
	}
});
export { i as scrollTrap };

//# sourceMappingURL=scroll-trap.js.map